'use client'

import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import type { SbBlokData } from '@storyblok/react'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import { stack } from 'ui/src/patterns/stack'
import { tokens } from 'ui/src/theme/tokens.css'
import { pageWrapper } from './StackBlock.css'

type HorizontalAlign = 'start' | 'center' | 'end'

const horizontalAlignMap: Record<HorizontalAlign, string> = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
}

type StackBlockProps = SbBaseBlockProps<{
  direction: 'row' | 'column'
  gap?: keyof typeof tokens.space
  horizontalAlign?: HorizontalAlign
  items: Array<SbBlokData>
}>

export function StackBlock({ blok, nested }: StackBlockProps) {
  const cssValue = horizontalAlignMap[blok.horizontalAlign ?? 'start']
  const isRow = blok.direction === 'row'

  const content = (
    <div
      className={stack({ direction: blok.direction, gap: blok.gap, flexWrap: isRow ? 'wrap' : undefined })}
      style={isRow ? { justifyContent: cssValue } : { alignItems: cssValue }}
    >
      {blok.items.map((item) => (
        <StoryblokComponent key={item._uid} blok={item} nested={true} />
      ))}
    </div>
  )

  if (nested) {
    return <div {...storyblokEditable(blok)}>{content}</div>
  }

  return (
    <div className={pageWrapper} {...storyblokEditable(blok)}>
      {content}
    </div>
  )
}

StackBlock.blockName = 'stack'
